module.exports = __webpack_public_path__ + "static/media/wave-grc-mob-3.fcf1f64b.svg";